export enum SocialProviderNameEnum {
  Facebook = 'Facebook' ,
  LinkedIn = 'LinkedIn' ,
  Google = 'Google',
  Twitter = 'Twitter',
  Microsoft = 'Microsoft'
}

export enum AuthenticationMethodEnum {
  Federated = 'FEDERATED',
  Managed = 'MANAGED'
}

export enum AuthenticationMethodEnums {
   Federated_Oauth = 'FEDERATED_OAUTH',
   Federated_Saml = 'FEDERATED_SAML',
   Federated= 'FEDERATED',
   Managed = 'MANAGED',
}